import React, { useContext, useState } from "react";
import ButtonSubmit from "../ButtonSubmit";
import { isValidGender, simplyClick } from "../../helpers";
import "./GenderForm.scss";
import { ContextProfileUser } from "../../lib/profileContext";
import { genderLabel, genderKey } from "../../constants";
import ProgressDots from "../ProgressDots/ProgressDots";

const GenderForm = ({ nextStep }) => {
  const { data, setData } = useContext(ContextProfileUser);

  const [errorGender, setErrorGender] = useState(null);
  const [genderWasChanged, setGenderWasChanged] = useState(false);

  const handlerSubmit = (e) => {
    e.preventDefault();

    if (!isValidGender(data.gender)) {
      setErrorGender("Please, choose your gender");
      return;
    }

    if (!genderWasChanged) {
      simplyClick("cl_lnd_i_am_st2_gender", {
        text: genderKey[data.gender],
      });
    }

    simplyClick("cl_lnd_i_am_st2_action", { text: "next" });
    nextStep();
  };

  const handleAddTypeGender = ({ target: { value } }) => {
    const genderValue = Number(value);

    setData((prev) => ({
      ...prev,
      gender: genderValue,
    }));

    setGenderWasChanged(true);
    setErrorGender(null);

    simplyClick("cl_lnd_i_am_st2_gender", {
      text: genderKey[genderValue],
    });
  };

  const options = Object.keys(genderLabel).map((key) => (
    <option value={key} key={key}>
      {genderLabel[key]}
    </option>
  ));

  return (
    <div className="promo__wrapper-gender">
      <form className="gender__form" onSubmit={handlerSubmit}>
        <div className="user__form-top">
          <h3>I am a</h3>
        </div>

        <div className="gender__form-content">
          <div className="custom-select gender">
            <div className="custom-select-me">
              <select
                className="gender"
                value={data.gender}
                onChange={handleAddTypeGender}
              >
                {options}
              </select>
            </div>
          </div>

          {errorGender && <p className="error">{errorGender}</p>}

          <ButtonSubmit
            className={"button__global button__gender"}
            text={"NEXT"}
            data-cokies="cookies"
          />

          <ProgressDots total={12} activeCount={2} />
        </div>
      </form>
    </div>
  );
};

export default GenderForm;
